module.exports = __webpack_public_path__ + "img/swimming.0032fef1.jpeg";